import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import brandVoice from './brandVoice.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import captacao from './captacao.json';
import captainExperience from './captainExperience.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import condominiums from './condominiums.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import laisAccount from './laisAccount.json';
import leadAlerts from './leadAlerts.json';
import leads from './leads.json';
import login from './login.json';
import macros from './macros.json';
import mercado from './mercado.json';
import prateleira from './prateleira.json';
import properties from './properties.json';
import propertyOffers from './propertyOffers.json';
import postSale from './postSale.json';
import realEstateFinance from './realEstateFinance.json';
import realEstateCommissionPlan from './realEstateCommissionPlan.json';
import realEstateCommissionInstallment from './realEstateCommissionInstallment.json';
import realEstateCommissionSupport from './realEstateCommissionSupport.json';
import realEstateBrokerDashboard from './realEstateBrokerDashboard.json';
import realEstateBrokerCommission from './realEstateBrokerCommission.json';
import realEstateBrokerInvestment from './realEstateBrokerInvestment.json';
import nucleoWorkOrders from './nucleoWorkOrders.json';
import salesDashboard from './salesDashboard.json';
import salesDashboardFilters from './salesDashboardFilters.json';
import salesDashboardActions from './salesDashboardActions.json';
import salesDetail from './salesDetail.json';
import salesDelivery from './salesDelivery.json';
import salesReview from './salesReview.json';
import salesPendingCharge from './salesPendingCharge.json';
import salesCommission from './salesCommission.json';
import salesEvents from './salesEvents.json';
import salesReceiptDraft from './salesReceiptDraft.json';
import salesDetailOperations from './salesDetailOperations.json';
import salesParties from './salesParties.json';
import salesProperty from './salesProperty.json';
import realEstateNavigation from './realEstateNavigation.json';
import gamification from './gamification.json';
import report from './report.json';
import redirecting from './redirecting.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import stories from './stories.json';
import supportTickets from './supportTickets.json';
import surveys from './surveys.json';
import teamsSettings from './teamsSettings.json';
import teamPerformance from './teamPerformance.json';
import targetManagement from './targetManagement.json';
import commissionManagement from './commissionManagement.json';
import visits from './visits.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import yearInReview from './yearInReview.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...brandVoice,
  ...bulkActions,
  ...campaign,
  ...captacao,
  ...captainExperience,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...condominiums,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...laisAccount,
  ...leadAlerts,
  ...leads,
  ...login,
  ...macros,
  ...mercado,
  ...prateleira,
  ...properties,
  ...propertyOffers,
  ...postSale,
  ...realEstateFinance,
  ...realEstateCommissionPlan,
  ...realEstateCommissionInstallment,
  ...realEstateCommissionSupport,
  ...realEstateBrokerDashboard,
  ...realEstateBrokerCommission,
  ...realEstateBrokerInvestment,
  ...nucleoWorkOrders,
  SALES: {
    ...salesDashboard.SALES,
    ...salesDashboardFilters.SALES,
    ...salesDashboardActions.SALES,
    ...salesDetail.SALES,
    ...salesDelivery.SALES,
    ...salesReview.SALES,
    ...salesPendingCharge.SALES,
    ...salesCommission.SALES,
    ...salesEvents.SALES,
    ...salesReceiptDraft.SALES,
    ...salesDetailOperations.SALES,
    DETAIL: {
      ...salesDetail.SALES.DETAIL,
      ...salesDetailOperations.SALES.DETAIL,
    },
  },
  ...salesParties,
  ...salesProperty,
  ...realEstateNavigation,
  ...gamification,
  ...report,
  ...redirecting,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...stories,
  ...supportTickets,
  ...surveys,
  ...teamsSettings,
  ...teamPerformance,
  ...targetManagement,
  ...commissionManagement,
  ...visits,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...yearInReview,
};
